import { PlayButtonIcon } from 'assets/icons';
import cx from 'classnames';
import React from 'react';
import { Container, Image } from 'react-bootstrap/';
import styled from 'styled-components';

import styles from './styles.module.scss';

interface VideoFrameProps {
  thumbnail: string;
  playVideo: () => void;
  width?: string;
  height?: string;
  hidePlayButton?: boolean;
}

const StyledPlayButtonIcon = styled(PlayButtonIcon)`
  & > g {
    & circle:nth-child(1) {
      fill: ${({ theme }) => theme.components.carousel.PlayButtonIcon?.borderColor};
    }
    & circle:nth-child(2) {
      fill: ${({ theme }) => theme.components.carousel.PlayButtonIcon?.bg};
    }
  }
`;

const StyledContainer = styled(Container)<{ width?: string; height?: string }>`
  width: ${({ width }) => width || ''};
  height: ${({ height }) => height || ''};

  & > .${styles.image} {
    min-height: ${({ height }) => height || ''};
  }
`;

const VideoFrame: React.FC<VideoFrameProps> = ({ thumbnail, playVideo, width, height, hidePlayButton = false }) => (
  <StyledContainer className={cx(styles.videoFrameContainer)} width={width} height={height} onClick={playVideo}>
    {!hidePlayButton && <StyledPlayButtonIcon className={cx(styles.button)} />}
    <Image src={thumbnail} className={cx(styles.image)} />
  </StyledContainer>
);

export default VideoFrame;
